import { useMutation } from "@tanstack/react-query";
import { createGameLessonVersion } from "api/services/game-lesson-service";
import { ICreateGameLessonVersionRequest } from "api/models/request/ICreateGameLessonVersionRequest";
import { useAuthContext } from "hooks/useAuthContext";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

export const useCreateGameLessonVersion = () => {
    const { userState } = useAuthContext();
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationFn: async (params: ICreateGameLessonVersionRequest) => {
            const workspaceId = userState.user.selectedWorkspace.workspaceId;
            if (!workspaceId) throw new Error("No workspace selected");

            const response = await createGameLessonVersion({ ...params, workspaceId });

            if (!response.success) {
                throw new Error(response.message ?? "createLessonVersion.error");
            }

            return response;
        },
        onSuccess: () => {
            enqueueSnackbar(t("createLessonVersion.success"), { variant: "success" });
        },
        onError: () => {
            enqueueSnackbar(t("createLessonVersion.error"), { variant: "error" });
        },
    });

    return { createGameLessonVersion: mutation.mutateAsync };
};
